export type ToastTone = 'error' | 'success';
type Listener = (message: string, tone: ToastTone) => void;

let listeners: Listener[] = [];

export function emitError(message: string) {
  listeners.forEach((listener) => listener(message, 'error'));
}

export function emitSuccess(message: string) {
  listeners.forEach((listener) => listener(message, 'success'));
}

export function subscribe(listener: Listener): () => void {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter((l) => l !== listener);
  };
}
